import parse, { type HTMLReactParserOptions } from 'html-react-parser';
import { cn } from '@/app_lib/utils/utils';

export const DescriptionParser = ({
  className,
  content,
  options,
}: {
  className?: string;
  content: string;
  options?: HTMLReactParserOptions;
}) => {
  return <span className={cn('description-parser contents', className)}>{parse(content, options)}</span>;
};
